import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Competitor } from '../../models/lookups/competitor.model';


@Injectable({
  providedIn: 'root'
})
export class CompetitorService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(competitor: Competitor) {
    return this.http.post(this.configurations.apiAddress + "/api/Competitor/save", competitor);
  }

  search(searchText: string, itemId?: number, itemBrandId?: number) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
      .set('itemId', itemId == undefined ? "" : itemId.toString())
      .set('itemBrandId', itemBrandId == undefined ? "" : itemBrandId.toString())
    return this.http.get(this.configurations.apiAddress + '/api/Competitor/search', { params: myParams });
  }

  getAllForRow(itemId?: number, itemBrandId?: number) {
    let myParams = new HttpParams()
      .set('itemId', itemId == undefined ? "" : itemId.toString())
      .set('itemBrandId', itemBrandId == undefined ? "" : itemBrandId.toString())
    return this.http.get(this.configurations.apiAddress + '/api/Competitor/getAllForRow', { params: myParams });
  }

  delete(id: number, force: boolean = false) {
    let myParams = new HttpParams().set('force', force.toString());
    return this.http.delete(this.configurations.apiAddress + '/api/Competitor/delete/' + id, { params: myParams });
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Competitor/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/Competitor/getAll');
  }

}
